
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import Table from '../../../../../../common/components/table';


export const RateCardValuesComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, rateCardFullRulesData,
}: any) => {

    return (

        <div className="w-full">
            <Table columnData={columnDefs} rowData={rateCardFullRulesData}
                onEdit={handleEdit} headingName="RateCard Rules Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>

    )
}
export default RateCardValuesComponent;
